import { render, staticRenderFns } from "./InfoPanelCharts.vue?vue&type=template&id=507e7a1a"
import script from "./InfoPanelCharts.vue?vue&type=script&lang=ts"
export * from "./InfoPanelCharts.vue?vue&type=script&lang=ts"
import style0 from "./InfoPanelCharts.vue?vue&type=style&index=0&id=507e7a1a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports